import { useMutation, type DefaultError, type UseMutationResult } from '@tanstack/react-query';

import { CreateTokenData, PasswordRecoveryData } from 'chaika-frontend-types/frontend-cms';

import { AuthApi } from '@api/AuthApi';

interface LoginVariables {
    email: string;
    password: string;
}

interface RecoverPasswordVariables {
    token: string;
    recovery: PasswordRecoveryData;
}

export function useLogin(): UseMutationResult<void, DefaultError, LoginVariables> {
    return useMutation({
        mutationFn: ({ email, password }: LoginVariables) => AuthApi.reserveLogin(email, password),
    });
}

export function useRecoverPassword(): UseMutationResult<void, DefaultError, RecoverPasswordVariables> {
    return useMutation({
        mutationFn: ({ token, recovery }: RecoverPasswordVariables) => AuthApi.recoveryPassword(token, recovery),
    });
}

export function useCreateRecoveryToken(): UseMutationResult<void, DefaultError, CreateTokenData> {
    return useMutation({
        mutationFn: (token: CreateTokenData) => AuthApi.createToken(token),
    });
}
